<cwt-cart-item-row [item]="items"></cwt-cart-item-row>